import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'limitset'
})
export class LimitSetPipe implements PipeTransform {
  transform(limitation:number,set:any): any {
    const arr = Array.from(set)
    if(arr.length<=limitation){
      return arr
    }else{
      return arr.slice(0,limitation)
    }
  }
}